import { useCallback, useContext, useState } from "react";
import GlobalContext from "../../context/GlobalContext";
import DataTableComponent from "./DataTableComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImport } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import swal from "../../services/swalConfig";
import CopyText from "../utilities/CopyText";
import { fetchSchedules } from "../../api/ScheduleApi";

import { tr } from "../../i18n";
const TableImportSchedule = ({ refresh, onSelect }) => {
  const { user, setLoading } = useContext(GlobalContext);
  const [reload, setReload] = useState(0);

  const fetchData = useCallback(
    async ({ page, perPage, search }) => {
      if (!user?.workspace?.company_id) return { data: [], total: 0 }; // Hindari request jika company_id belum tersedia

      const response = await fetchSchedules({
        companyId: user.workspace.company_id,
        page,
        perPage,
        search,
      });

      const numberedData = response.data.map((item, index) => ({
        ...item,
        no: (page - 1) * perPage + index + 1,
      }));

      return { data: numberedData, total: response.total };
    },
    [user, reload, refresh] // Tambahkan dependency agar berubah saat user berubah
  );

  const handleImport = (data) => {
    if (onSelect) onSelect(data);
  };

  const columns = [
    {
      name: "ID",
      cell: (row) => <b>{row.id}</b>,
      sortable: true,
      wrap: true,
      width: "23%",
    },
    {
      name: tr("shared:name"),
      selector: (row) => row.template_name,
      sortable: true,
      wrap: true,
    },
    {
      name: tr("shared:actions"),
      center: true,
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={() => handleImport(row.schedule)}
            className="btn btn-light btn-sm"
          >
            <FontAwesomeIcon icon={faFileImport} className="me-1" /> {" "}{tr("common:breadcrumb.import")}
          </button>
        </div>
      ),
      style: {
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      },
    },
  ];

  return (
    <div>
      <DataTableComponent columns={columns} fetchData={fetchData} />
    </div>
  );
};

export default TableImportSchedule;
